exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag-borders[data-v-1fd7b87c]{border-left-color:#e4454a;border-right-color:#e4454a}.tag[data-v-1fd7b87c]:first-of-type{border-left-color:transparent}.tag[data-v-1fd7b87c]:last-of-type{border-right-color:transparent}.tag:last-of-type>.slider-button[data-v-1fd7b87c]{display:none!important}.tag-text[data-v-1fd7b87c]{color:#323232}.hoveredTag[data-v-1fd7b87c]{cursor:pointer;color:#631e20;text-decoration:line-through 20%}.slider-button[data-v-1fd7b87c]{color:#fff}.slider-button[data-v-1fd7b87c]:hover{color:#631e20}", ""]);

// exports
